/**
 * Базовый модуль для вызовов API
 */
import ApiCaller, {TApiCallConfig} from "./ApiCaller";

/**
 * Создание объекта ApiCaller для вызова API
 *
 * @param {(void|Object)} config - Параметры вызова
 * @returns {ApiCaller} Настроенный объект для вызовов API
 */
const apiCall = (config?: Partial<TApiCallConfig>): ApiCaller => new ApiCaller(config);

export {default as ApiError} from "./ApiError";
export {apiCall};
